var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_1103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 14.6666C13.7018 14.6666 14.0003 14.3682 14.0003 14C14.0003 13.6318 13.7018 13.3333 13.3337 13.3333C12.9655 13.3333 12.667 13.6318 12.667 14C12.667 14.3682 12.9655 14.6666 13.3337 14.6666Z",
    stroke: "#0B0B0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 14.6666C6.36786 14.6666 6.66634 14.3682 6.66634 14C6.66634 13.6318 6.36786 13.3333 5.99967 13.3333C5.63148 13.3333 5.33301 13.6318 5.33301 14C5.33301 14.3682 5.63148 14.6666 5.99967 14.6666Z",
    stroke: "#0B0B0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 0.666687H3.33366L5.12033 9.59335C5.18129 9.90028 5.34826 10.176 5.59202 10.3722C5.83578 10.5684 6.14079 10.6727 6.45366 10.6667H12.9337C13.2465 10.6727 13.5515 10.5684 13.7953 10.3722C14.0391 10.176 14.206 9.90028 14.267 9.59335L15.3337 4.00002H4.00033",
    stroke: "#0B0B0C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_1103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart1);
export default __webpack_public_path__ + "static/media/shopping-cart_1.6f5abef66defefdfc60f16713dee1c16.svg";
export { ForwardRef as ReactComponent };